'use strict';

module.exports = [
    function () {

        return {
            restrict: 'E',
            scope: {
                label: '@',
                filters: '=',
                updateCallback: '&',
                inactive: '=?'
            },
            templateUrl: '/partial/app.directives.filter_select',
            link: function (scope, element, attributes) {
                scope.filterCount = 0;
                scope.allSelected = false;

                scope.$watch('filters', (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        scope.updateFilterCount();
                    }
                });

                scope.$watch('inactive', (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        scope.inactive = newVal;
                    }
                });

                scope.openMenu = ($mdOpenMenu, ev) => {
                    $mdOpenMenu(ev);
                };

                scope.updateFilters = () => {
                    scope.updateFilterCount();
                    scope.updateCallback({ filters: scope.filters });
                };

                scope.updateFilterCount = () => {
                    scope.filterCount = 0;

                    if (!(scope.filters instanceof Array)) return;

                    scope.filters.map((filter) => {
                        if (filter.enabled) {
                            scope.filterCount++;
                        }
                    });

                    scope.allSelected = (scope.filterCount == scope.filters.length );
                };

                scope.revertInactive = () => {
                    scope.inactive = !scope.inactive || false;
                    scope.updateFilters();
                    scope.updateFilterCount();
                };

                scope.checkBoxToggle = (isSelected) => {

                    for (let i = 0; i < scope.filters.length; i++) {

                        scope.filters[i].enabled = isSelected;
                    }

                    scope.updateFilters();
                    scope.updateFilterCount();
                };

                scope.updateFilterCount();
            }
        };
    }
];

